
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/accessibility-statement",
      function () {
        return require("private-next-pages/legal/accessibility-statement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/accessibility-statement"])
      });
    }
  